module.exports = __webpack_public_path__ + "static/media/us-gold-currency-logo-white.28cc7a27.png";